import { Button, Flex, Empty } from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';
import { IObject } from 'common/interfaces/hierarchy-entities';
import { downloadObject } from '../utils/export';

interface IFileViewerProps {
  dataObject: IObject
}

export const FileViewer = ({ dataObject }: IFileViewerProps) => {
  const { t } = useTranslation();

  return (
    <Flex justifyContent="center">
      <Empty text={t(translations.viewer_fileContentNotShown)}>
        <Button label={t(translations.importExport_download)} onClick={() => downloadObject(dataObject)} />
      </Empty>
    </Flex>
  );
};